import { select, put } from 'redux-saga/effects';
import { selectIncomingSmsQueues, setIncomingSmsQueues } from '../../../state/ua/uaSlice';

export default function* rejectSms({ payload: { session: smsSession } }) {
  // remove the session from the list of incoming sms queue sessions
  const currentIncomingSmsQueues = yield select(selectIncomingSmsQueues);
  const updatedCurrentIncomingSmsQueues = currentIncomingSmsQueues.filter((session) => session.session_id !== smsSession.session_id);

  yield put(setIncomingSmsQueues(updatedCurrentIncomingSmsQueues));
}
